export default __webpack_public_path__ + "static/Homekit_1080p_Smartphone_02-ad878f652500a936d9be793e431ce89a.webp";